import { IFormField } from '../IForm.types';
import { ItemForm } from './ItemForm';

export class InputCheckboxGroupForm extends ItemForm {
  type= 'selectboxes';
  values:any;
  constructor(field: IFormField) {
    super(field);
    this.values = field.admittedValues
    .split(',')
    .map((v) => v.trim())
    .map((value) => ({ value, label: value }));
  }
}
